import * as types from '../actions/ActionTypes';

const explicitCheck = (list) => {
  let items = list.tracks.items;
  return items.filter(item => item.track.explicit);
};

const playlist = (state = [], action) => {
  switch(action.type) {
    case types.SPOTIFY_PLAYLIST_SUCCESS:
      return Object.assign({}, state, { playlists: action.lists});
    
    case types.SPOTIFY_GET_PLAYLIST_SUCCESS:
      return Object.assign({}, state, { playlist: action.playlist });
    
    case types.PLAYLIST_CHECK:
      let explicitTracks = explicitCheck(action.list);
      return Object.assign({}, state, {explicit: explicitTracks});
    
    case types.SPOTIFY_CREATE_PLAYLIST_SUCCESS:
      return Object.assign({}, state, {newlist: action.playlist });

    case types.SPOTIFY_ADD_TRACKS_SUCCESS:
      console.log(action);
      return state;
    
    case types.PLAYLIST_DUPLICATE_MATCH:
      console.log(action.match);
      return action.match;

    default:
      return state;
  }
};

export default playlist;


// WEBPACK FOOTER //
// ./src/reducers/spotifyPlaylist.js